"use strict";

require("core-js/modules/es.array.reduce.js");

var _defineProperty = require("/media/konapun/Data/Programming/projects/konapun.github.io/node_modules/@babel/runtime/helpers/defineProperty");

var _slicedToArray = require("/media/konapun/Data/Programming/projects/konapun.github.io/node_modules/@babel/runtime/helpers/slicedToArray");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

require("source-map-support/register");

var _awilix = require("awilix");

var _channel = _interopRequireDefault(require("./channel"));

var _command = _interopRequireDefault(require("./command"));

var _compiler = _interopRequireDefault(require("./compiler"));

var _config = _interopRequireDefault(require("./config"));

var _environment = _interopRequireDefault(require("./environment"));

var _interaction = _interopRequireDefault(require("./interaction"));

var _job = _interopRequireDefault(require("./job"));

var _listener = _interopRequireDefault(require("./listener"));

var _messenger = _interopRequireDefault(require("./messenger"));

var _permission = _interopRequireDefault(require("./permission"));

var _persistence = _interopRequireDefault(require("./persistence"));

var _plugin = _interopRequireDefault(require("./plugin"));

var _signal = _interopRequireDefault(require("./signal"));

var _user = _interopRequireDefault(require("./user"));

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var services = {
  channelService: _channel.default,
  commandService: _command.default,
  compilerService: _compiler.default,
  configService: _config.default,
  environmentService: _environment.default,
  interactionService: _interaction.default,
  jobService: _job.default,
  listenerService: _listener.default,
  messengerService: _messenger.default,
  permissionService: _permission.default,
  persistenceService: _persistence.default,
  pluginService: _plugin.default,
  signalService: _signal.default,
  userService: _user.default
};

var serviceRegistry = function serviceRegistry(container) {
  return {
    initialize: function initialize(frame) {
      container.register(Object.entries(services).map(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];

        return _defineProperty({}, key, (0, _awilix.asFunction)(value(frame)).singleton());
      }).reduce(function (acc, entry) {
        return _objectSpread({}, acc, {}, entry);
      }, {}));
    }
  };
};

var _default = serviceRegistry;
exports.default = _default;